// extracted by mini-css-extract-plugin
export var banner = "banner-module--banner--W+C8D";
export var banner__description = "banner-module--banner__description--HQnQu";
export var banner__inner = "banner-module--banner__inner--qjQjj";
export var banner__link = "banner-module--banner__link--LireT";
export var banner__wrapper = "banner-module--banner__wrapper--XxM1+";